import PortalUserTypes from 'store/actionTypes/portalUser'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  portalRole: {},
  vehicles: [],
  companies: [],
  gdpr: {},
  role: {},
  directVehicle: {
    list: [],
    pagination: {}
  },
  commSystemLog: {
    list: [],
    pagination: {}
  }
}

const portalUser = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PortalUserTypes.GET_PORTAL_USER_LIST_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case PortalUserTypes.GET_PORTAL_USER_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload?.user
      }
    case PortalUserTypes.GET_PORTAL_USER_PORTAL_ROLE_SUCCESS:
      return {
        ...state,
        portalRole: payload
      }
    case PortalUserTypes.GET_VEHICLE_PORTAL_USER_SUCCESS:
      return {
        ...state,
        vehicles: payload?.items
      }
    case PortalUserTypes.GET_COMPANIES_PORTAL_USER_SUCCESS:
      return {
        ...state,
        companies: payload?.userCompanies
      }
    case PortalUserTypes.UPDATE_FILTER_PORTAL_USER_SUCCESS:
      return {
        ...state,
        filter: payload
      }
    case PortalUserTypes.GET_GDPR_PORTAL_USER_SUCCESS:
      return {
        ...state,
        gdpr: payload?.preferences
      }
    case PortalUserTypes.GET_ROLE_PORTAL_USER_SUCCESS:
      return {
        ...state,
        role: payload
      }
    case PortalUserTypes.GET_DIRECT_VEHICLES_PORTAL_USER_SUCCESS:
      return {
        ...state,
        directVehicle: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case PortalUserTypes.GET_COMM_SYSTEM_LOGS_PORTAL_USER_SUCCESS:
      return {
        ...state,
        commSystemLog: {
          list: (payload?.items || []).map((t) => ({
            ...t,
            dtCommSystemLog: t.commSystemLogConvertedDate || t.dtCommSystemLog,
            status: t.status || t.statusId,
            dtStatus: t.dtStatus || t.statusDate
          })),
          pagination: payload?.meta
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default portalUser
